import { render, staticRenderFns } from "./AbsenceRequestList.vue?vue&type=template&id=5734b9c0&lang=pug&"
import script from "./AbsenceRequestList.vue?vue&type=script&lang=js&"
export * from "./AbsenceRequestList.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceRequestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AbsenceRequestList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VIcon,
})
